import * as ApiManager from '../_manager';
import store from '@/store';

export const adminConsumer = {
  get: payload => {
    return ApiManager.callApi (
      `/admin/company/${store.getters['company/getSelected']}/consumer/get`,
      payload
    );
  },
  update: payload => {
    return ApiManager.callApi (
      `/admin/company/${store.getters['company/getSelected']}/consumer/update`,
      payload
    );
  },

  getConsumerList: payload => {
    return ApiManager.callApi (
      `/admin/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/consumer/list`,
      payload
    );
  },

  getAllConsumerList: payload => {
    return ApiManager.callApi (`/admin/consumer/list`, payload);
  },

  showPassword: payload => {
    return ApiManager.callApi (
      `/admin/company/${store.getters['company/getSelected']}/consumer/show_password`,
      payload
    );
  },

  sendReminders: payload => {
    return ApiManager.callApi (
      `/admin/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/consumer/send_reminders`,
      payload
    );
  },

  detachConsumer: payload => {
    return ApiManager.callApi (
      `/admin/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/consumer/detachConsumer`,
      payload
    );
  },

  detachAllConsumer: payload => {
    return ApiManager.callApi (
      `/admin/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/consumer/detachAllConsumer`,
      payload
    );
  },

  createByAdmin: payload => {
    return ApiManager.callApi (
      `/admin/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/consumer/create`,
      payload
    );
  },

  exportReport: payload => {
    return ApiManager.callApi (
      `/admin/company/${store.getters['company/getSelected']}/consumer/` +
        payload.consumer_id +
        `/exportReport`,
      payload
    );
  },

  exportAllConsumersReport: payload => {
    return ApiManager.callApi (
      `/admin/company/${store.getters['company/getSelected']}/consumer/exportAllConsumersReport`,
      payload
    );
  },

  deleteConsumerDetails: payload => {
    return ApiManager.callApi (`/admin/consumer/deleteConsumerDetails`, payload)
  }
};
